__turbopack_context__.v({
  "contentPageSidebar": "ContentPageSidebar-module-scss-module__JJIvzq__contentPageSidebar",
});
